/*
 * The Agents menu's open state and the Agents button's "gulp", shared by the
 * sidebar button and the banner layer. The button registers itself as the
 * anchor so banners and the menu come out of (and go back into) it.
 */
import { create } from "zustand";

type State = {
  open: boolean;
  /** Bumped when a banner is pulled back into the button; keys its bounce. */
  gulp: number;
  /** The notifications sheet is open: no banners over it. */
  sheetOpen: boolean;
  anchor: HTMLElement | null;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  bumpGulp: () => void;
  setSheetOpen: (open: boolean) => void;
  setAnchor: (el: HTMLElement | null) => void;
};

export const useAgentsTrayStore = create<State>((set) => ({
  open: false,
  gulp: 0,
  sheetOpen: false,
  anchor: null,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
  bumpGulp: () => set((s) => ({ gulp: s.gulp + 1 })),
  setSheetOpen: (sheetOpen) => set({ sheetOpen }),
  setAnchor: (anchor) => set({ anchor })
}));
